import { useState } from "react";
import { Eye } from "lucide-react";
import { useApi, ago } from "../../lib/api";
import { SentimentBadge, SourceTag, TwiFlag, SectionHead } from "../Badges";

const FILTERS = [["", "All"], ["positive", "Positive"], ["neutral", "Neutral"], ["negative", "Negative"], ["despite", "Mentions DESPITE"]];

const Card = ({ a, big }) => (
  <article className={`panel panel-hover overflow-hidden flex flex-col ${big ? "md:col-span-2 md:row-span-2" : ""}`} data-testid={`news-card-${a.article_id}`}>
    {a.photo && <div className={`${big ? "h-72" : "h-40"} overflow-hidden`}><img src={a.photo} alt="" loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" /></div>}
    <div className="p-4 flex flex-col gap-2 flex-1">
      <div className="flex flex-wrap items-center gap-2">
        <SentimentBadge value={a.sentiment} />
        {a.category && <span className="pill pill-slate">{a.category}</span>}
        {a.political && <span className="pill pill-gold">Political</span>}
        {a.needs_twi_validation && <TwiFlag />}
      </div>
      <a href={a.url} target="_blank" rel="noreferrer" className={`font-semibold text-ink hover:text-[color:var(--gold)] transition-colors ${big ? "text-xl md:text-2xl font-display" : "text-sm"}`}>{a.title}</a>
      {big && <p className="text-sm text-slate-400 line-clamp-3">{a.summary}</p>}
      {a.entities?.length > 0 && <div className="text-[11px] text-gold">Tagged: {a.entities.join(", ")} · {a.principals.join(", ")}</div>}
      <div className="mt-auto flex items-center justify-between pt-2">
        <SourceTag source="Peacefmonline.com" url={a.url} />
        <span className="font-data text-[10px] text-slate-500 flex items-center gap-2">{a.views != null && <><Eye size={11} />{a.views}</>} {ago(a.published_at)}</span>
      </div>
    </div>
  </article>
);

export const NewsFeed = () => {
  const [f, setF] = useState("");
  const q = f === "despite" ? "despite_only=true" : f ? `sentiment=${f}` : "";
  const { data } = useApi(`/public/news?limit=13&${q}`);
  const items = data?.items || [];
  return (
    <section id="news" className="max-w-7xl mx-auto px-5 md:px-8 py-20" data-testid="news-section">
      <SectionHead eyebrow="Peacefmonline.com · live scrape" title="Top stories, scored for sentiment">
        Pulled from Peacefmonline.com's public article feed and classified by Claude Sonnet 4.5. Every card links to the original. Last scrape: {ago(data?.last_scrape)}.
      </SectionHead>
      <div className="flex flex-wrap gap-2 mb-6">
        {FILTERS.map(([k, l]) => (
          <button key={l} onClick={() => setF(k)} data-testid={`news-filter-${l.toLowerCase().replace(" ", "-")}`}
            className={`pill ${f === k ? "pill-gold" : "pill-slate"} !text-[11px] !py-1.5 !px-3 transition-colors`}>{l}</button>
        ))}
      </div>
      {!data && <div className="font-data text-xs text-slate-500">Loading live feed…</div>}
      {data && items.length === 0 && <div className="panel p-6 text-sm text-slate-400" data-testid="news-empty">No items match this filter yet. The scraper refreshes hourly.</div>}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {items.map((a, i) => <Card key={a.article_id} a={a} big={i === 0} />)}
      </div>
    </section>
  );
};
